// eslint-disable-next-line import/prefer-default-export
export var animation = {
  durationBase: '0.0s',
  durationSlow: '0.0s',
  durationFast: '0.0s'
};